<div class="row mb-3">
    <div class="col-12">
        <span class="d-inline-flex p-2 h5 fw-bold">{{ 'study-editor.sample-list.title' | translate}}</span>: <span class="fst-italic value-chip-light">{{sampleList?.listName}}</span>
    </div>
</div>
<div>
    <div class="row mb-3">
        <div class="col-12">
            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <div class="col">
                    <span jhiTranslate="global.total.entries" [translateValues]="{param: numberOfEntries}"></span>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="row mb-3">
        <div class="col-10">
            <div class="col d-flex align-items-center">
                <label class="col-auto" jhiTranslate="global.records.per.page">Records per page: </label>
                <div class="col-1 ms-2">
                    <select class="form-select form-select-sm"
                            [(ngModel)]="pageSize"
                            (change)="onPageSizeChange($event)">
                        <option value="50">50</option>
                        <option value="75">75</option>
                        <option value="100">100</option>
                    </select>
                </div>
                <div class="col-5">
                    <jhi-selection-count [showSelectAll]="false"
                                         [isSelectAll]="isSelectAll"
                                         [totalItemsSize]="numberOfEntries"
                                         [selectedItemsSize]="selectedItems.size"
                                         (deselectAction)="clearSelected()"
                                         (selectAllAction)="selectAll($event)"></jhi-selection-count>
                </div>
            </div>
        </div>
        <div class="col-2 d-flex justify-content-end align-items-center">
            <div ngbDropdown container="body" class="float-end" placement="bottom-right" *ngIf="isShowAction">
                <button class="btn btn-info btn-sm" id="actionMenu" ngbDropdownToggle>
                    <span>{{ 'study-editor.sample-list.actions' | translate }}</span>
                </button>
                <div ngbDropdownMenu aria-labelledby="actionMenu">
                    <button *jhiHasAnyAuthority="SAMPLE_LABEL_PRINTING_PERMISSIONS" class="dropdown-item" type="submit" (click)="sampleListPrintingLabels()">{{'study-editor.sample-list.actions.export' | translate}}
                    </button>
                    <button *jhiHasAnyAuthority="DELETE_SAMPLE_LISTS_PERMISSIONS" class="dropdown-item" type="submit" (click)="removeEntries()">{{'study-editor.sample-list.actions.delete-samples' | translate}}
                    </button>
                    <div class="btn-group dropstart" ngbDropdown *ngIf="principal.hasAnyAuthorityDirect(MS_IMPORT_GENOTYPES_FROM_GIGWA) || principal.hasAnyAuthorityDirect(MS_IMPORT_GENOTYPES_FROM_FILE)">
                        <button class="dropdown-item" type="button" ngbDropdownToggle>{{'study-editor.sample-list.actions.import-genotypes' | translate}}
                        </button>
                        <div class="dropdown-menu" ngbDropdownMenu>
                            <button *jhiHasAnyAuthority="MS_IMPORT_GENOTYPES_FROM_GIGWA" class="dropdown-item" type="submit" (click)="importFromGigwa()">{{'study-editor.sample-list.actions.import-genotypes.from-gigwa' | translate}}
                            </button>
                            <button  *jhiHasAnyAuthority="MS_IMPORT_GENOTYPES_FROM_FILE" class="dropdown-item" type="submit" (click)="importFromFile()">{{'study-editor.sample-list.actions.import-genotypes.from-file' | translate}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ms-1">
                <jhi-column-selector [displayedColumns]="displayedColumns"
                                     [columnDataService]="columnDataService"
                                     (reset)="onColumnSelectorReset()"
                                     [showGroupToggle]="false"></jhi-column-selector>
            </div>
        </div>
    </div>
    <div class="table-responsive" *ngIf="entries">
        <div class="custom-scroll-style adjustable-height">
            <table class="table table-striped table-curved">
                <thead class="sticky-header">
                <tr>
                    @for (column of displayedColumns; track trackColumnsById(column)) {
                        @if (column.selected && column.visible) {
                            <th><span>
                                @if (column.termId === CHECKBOX) {
                                    <input type="checkbox" class="form-check-input m-1"
                                           [ngbTooltip]="'global.select.current.page' | translate"
                                           [checked]="isPageSelected()"
                                           (click)="onSelectPage()">
                                }

                                @if (getStaticColumnLabelKey(column.termId)) {
                                    {{ getStaticColumnLabelKey(column.termId) | translate }}
                                } @else {
                                    {{ column.displayName || column.name }}
                                }
                            </span></th>
                        }
                    }
                </tr>
                </thead>
                <tbody>
                    @for (entry of entries; track entry.sampleId; let row = $index) {
                        <tr [class.selected]="isSelected(entry.sampleId)"
                            (click)="toggleSelect($event, row, entry); $event.stopPropagation()"
                            (mousedown)="preventDefaultOnShiftKey($event)">
                            @for (column of displayedColumns; track column.id; let col = $index) {
                                @if (column.selected && column.visible) {
                                    <td>
                                        @switch (column.id) {
                                            @case (CHECKBOX) {
                                                <input type="checkbox" class="form-check-input" [checked]="isSelected(entry.sampleId)" (click)="toggleSelect($event, row, entry, true); $event.stopPropagation()">
                                            }
                                            @case (SAMPLE_ENTRY) {
                                                <span>{{entry.entryNo}}</span>
                                            }
                                            @case (DESIGNATION) {
                                                @if (hasViewGermplasmDetailsPermission) {
                                                    <span><a  href="javascript:void(0)" class="link" (click)="germplasmDetailsPopupService.open(entry.gid)"><truncate-span [textInput]="entry.designation" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></a></span>
                                                } @else {
                                                    <truncate-span [textInput]="entry.designation" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span>
                                                }
                                            }
                                            @case (GID) {
                                                @if (hasViewGermplasmDetailsPermission) {
                                                    <span><a  href="javascript:void(0)" class="link" (click)="germplasmDetailsPopupService.open(entry.gid)"><truncate-span [textInput]="entry.gid"></truncate-span></a></span>
                                                } @else {
                                                    <truncate-span [textInput]="entry.gid"></truncate-span>
                                                }
                                            }
                                            @case (SAMPLE_NAME) {
                                                <truncate-span [textInput]="entry.sampleName"></truncate-span>
                                            }
                                            @case (PLOT_NO) {
                                                <span>{{entry.enumerator}}</span>
                                            }
                                            @case (SAMPLE_NO) {
                                                <span>{{entry.sampleNumber}}</span>
                                            }
                                            @case (TAKEN_BY) {
                                                <span>{{entry.takenBy}}</span>
                                            }
                                            @case (SAMPLING_DATE) {
                                                <span>{{entry.samplingDate}}</span>
                                            }
                                            @case (SAMPLE_UUID) {
                                                <span>{{entry.sampleBusinessKey}}</span>
                                            }
                                            @case (PLATE_ID) {
                                                <span>{{entry.plateId}}</span>
                                            }
                                            @case (WELL) {
                                                <span>{{entry.well}}</span>
                                            }
											@case (OBS_UNIT_ID) {
												<span>{{entry.observationUnitId}}</span>
											}
                                            @default {
                                                <span>-</span>
                                            }
                                        }
                                    </td>
                                }
                            }
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
    <div *ngIf="entries && entries.length">
        <div class="d-flex justify-content-between align-items-center mt-3">

            <div>
				<span name="pageDescription" class="text-muted" jhiTranslate="study-editor.pagination.entry-count"
					  [translateValues]="{param1: (currentPage - 1) * pageSize + 1, param2: Math.min(currentPage * pageSize, numberOfEntries), param3: numberOfEntries}"></span>
            </div>

            <div>
                <div class="d-inline-block ms-3">
                    <ngb-pagination
                            [collectionSize]="numberOfEntries"
                            [(page)]="currentPage"
                            [pageSize]="pageSize"
                            [maxSize]="10"
                            [ellipses]="true"
                            [boundaryLinks]="true"
                            [rotate]="true"
                            (pageChange)="onPageChange($event)">
                    </ngb-pagination>
                </div>
                <div class="d-inline-block ms-3">
                    <label for="goToPage" class="me-2" jhiTranslate="study-editor.pagination.go-to">Go to page:</label>
                    <input id="goToPage" type="number" class="form-control d-inline-block w-auto"
                           [min]="1" [max]="Math.ceil((numberOfEntries) / pageSize)"
                           [(ngModel)]="currentPage"
                           (change)="onPageChange(currentPage); $event.preventDefault()"/>
                </div>
            </div>
        </div>
    </div>
</div>
